import { render, staticRenderFns } from "./start-ebook-modal.vue?vue&type=template&id=2fa3fd1d&"
import script from "./start-ebook-modal.vue?vue&type=script&lang=js&"
export * from "./start-ebook-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports